
import Vue, { PropType } from "vue";
import { TIcon, EIcons } from '.'


export default Vue.extend({
	props: {
		type: {
			default: 'home',
			type: String as PropType<TIcon>
		}
	},
	computed: {
		//  iconClass():string{
		// 	return EIcons[this.type]
		//  }
		iconClass: {
			get(): string {
				return EIcons[this.type as TIcon]
			},
			// set(v){

			// }
		}
	}
})
